import { getByName } from './utils';

export function createNavigationState() {
  return {
    history: [],
    index: -1,
    lastBrowseCategory: null
  };
}

export function pushNavigationHistory(navigationState, entityType, entityName) {
  const current = navigationState.history[navigationState.index];
  if (current && current.entityType === entityType && current.entityName === entityName) {
    return;
  }

  navigationState.history.splice(navigationState.index + 1);
  navigationState.history.push({ entityType, entityName });
  navigationState.index = navigationState.history.length - 1;
}

export function clearNavigationHistory(navigationState, connectionVectorLayer, referencedVectorLayer) {
  navigationState.history.length = 0;
  navigationState.index = -1;
  connectionVectorLayer.changed();
  referencedVectorLayer.changed();
}

export function canGoBack(navigationState) {
  return navigationState.index > 0;
}

export function canGoForward(navigationState) {
  return navigationState.index >= 0 && navigationState.index < navigationState.history.length - 1;
}

export function goBack(navigationState) {
  if (canGoBack(navigationState)) {
    navigationState.index -= 1;
    return navigationState.history[navigationState.index];
  }
  return null;
}

export function goForward(navigationState) {
  if (canGoForward(navigationState)) {
    navigationState.index += 1;
    return navigationState.history[navigationState.index];
  }
  return null;
}

export function goToHistoryIndex(navigationState, targetIndex) {
  if (!Number.isNaN(targetIndex) && targetIndex >= 0 && targetIndex < navigationState.history.length) {
    navigationState.index = targetIndex;
    return navigationState.history[navigationState.index];
  }
  return null;
}

export function renderNavigationHeader(navigationState) {
  const canGoBackVal = canGoBack(navigationState);
  const canGoForwardVal = canGoForward(navigationState);
  const hasHistory = navigationState.history.length > 0;
  
  const breadcrumbs = navigationState.history
    .map((item, index) => {
      const label = item.entityName;
      if (index === navigationState.index) {
        return `<span class="breadcrumb-current">${label}</span>`;
      }
      return `<button class="breadcrumb-link" data-history-index="${index}">${label}</button>`;
    })
    .join('<span class="breadcrumb-separator">/</span>');

  let html = '<div class="history-controls">';
  html += '<button class="history-nav" id="open-browse">Browse</button>';
  html += `<button class="history-nav" data-direction="back" ${canGoBackVal ? '' : 'disabled'}>Back</button>`;
  html += `<button class="history-nav" data-direction="forward" ${canGoForwardVal ? '' : 'disabled'}>Forward</button>`;
  html += `<button class="history-nav" id="clear-history" ${hasHistory ? '' : 'disabled'}>Clear</button>`;
  html += '</div>';
  if (breadcrumbs) {
    html += `<div class="breadcrumbs">${breadcrumbs}</div>`;
  }

  return html;
}
